var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[(_vm.widgets.length < 1)?_c('video-tutorial'):_vm._e(),_vm._l((_vm.widgets),function(widget){return _c('Base',{key:widget.uuid,attrs:{"widget":widget}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }